import React from 'react';

const BlackCircleFavicon: React.FC = () => {
  // Create a canvas element
  const canvasRef = React.useRef<HTMLCanvasElement>(null);

  React.useEffect(() => {
    if (!canvasRef.current) return;
    
    // Set canvas dimensions (should be a power of 2)
    const canvas = canvasRef.current;
    canvas.width = 512;
    canvas.height = 512;
    
    // Get the 2D context
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    
    // Draw a black circle
    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.arc(256, 256, 256, 0, 2 * Math.PI);
    ctx.fill();
    
    // Export the canvas as PNG
    const faviconData = canvas.toDataURL('image/png');
    
    // Create a download link
    const downloadLink = document.createElement('a');
    downloadLink.href = faviconData;
    downloadLink.download = 'black-circle-favicon.png';
    
    // Add download link to the document
    document.body.appendChild(downloadLink);
  }, []);

  const downloadImage = () => {
    if (!canvasRef.current) return;
    
    // Export the canvas as PNG
    const faviconData = canvasRef.current.toDataURL('image/png');
    
    // Create a download link
    const downloadLink = document.createElement('a');
    downloadLink.href = faviconData;
    downloadLink.download = 'black-circle-favicon.png';
    
    // Trigger download
    downloadLink.click();
  };
  
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      minHeight: '100vh',
      backgroundColor: '#000000',
    },
    canvas: {
      border: '1px solid rgba(255, 255, 255, 0.1)',
      marginBottom: '40px',
      width: '256px',
      height: '256px',
    },
    button: {
      padding: '12px 24px',
      backgroundColor: '#FFFFFF',
      color: '#000000',
      border: 'none',
      fontSize: '14px',
      textTransform: 'uppercase' as const,
      letterSpacing: '1px',
      cursor: 'pointer',
      marginTop: '20px',
    },
    info: {
      color: '#CCCCCC',
      textAlign: 'center' as const,
      maxWidth: '500px',
      marginBottom: '40px',
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={{ color: 'white', marginBottom: '20px' }}>Black Circle Favicon</h1>
      <div style={styles.info}>
        <p>A simple black circle favicon for NOPRBLM. This can be used as favicon.ico, logo192.png, and logo512.png.</p>
      </div>
      
      <canvas 
        ref={canvasRef} 
        style={styles.canvas}
      />
      
      <button 
        style={styles.button}
        onClick={downloadImage}
      >
        Download Favicon
      </button>
    </div>
  );
};

export default BlackCircleFavicon;